import { SubscriptionApp } from "@/features/organization-app";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_organization-access/_overlay-sidebar/organization/$organizationSlug/subscription/$subscriptionId"
)({
  component: Subscription
});

function Subscription() {
  const { subscriptionId } = Route.useParams();
  return <SubscriptionApp subscriptionId={subscriptionId} />;
}
